import React from 'react';
import {
  bool, func, oneOf, shape, string
} from 'prop-types';
import { Card } from '../card/card';
import { Dropdown } from '../dropdown/dropdown';
import { Swatch } from '../swatch/swatch';
import { Tile } from '../tile/tile';

export const SuperSkuAttributeValue = (props) => {
  const {
    attributeType,
    channel,
    displayInToolTip,
    hoveredCombinationDetails,
    isAvailable,
    isSelected,
    isTooltipsEnabled,
    miniSwatch,
    onClick,
    onMouseEnter,
    onMouseLeave,
    swatchCardCombinationDetails,
    swatchGuid,
    value
  } = props;

  const isCard = attributeType === 'card';
  const isDropdown = attributeType === 'dropdown';
  const isSwatch = attributeType === 'swatch';
  const isTile = attributeType === 'tile';

  return (
    <>
      {isSwatch
      && (
        <Swatch
          isSelected={isSelected}
          isAvailable={isAvailable}
          value={value}
          swatchGuid={swatchGuid}
          onClick={onClick}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          isTooltipsEnabled={isTooltipsEnabled}
          hoveredCombinationDetails={hoveredCombinationDetails}
          channel={channel}
          miniSwatch={miniSwatch}
          displayInToolTip={displayInToolTip}
        />
      )}
      {isTile
      && (
        <Tile
          isSelected={isSelected}
          isAvailable={isAvailable}
          value={value}
          onClick={onClick}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          isTooltipsEnabled={isTooltipsEnabled}
          hoveredCombinationDetails={hoveredCombinationDetails}
          channel={channel}
        />
      )}
      {isCard
      && (
        <Card
          isSelected={isSelected}
          attributeValue={value}
          onClick={onClick}
          swatchCardCombinationDetails={swatchCardCombinationDetails}
        />
      )}
      {isDropdown
      && (
        <Dropdown
          isAvailable={isAvailable}
          onClick={onClick}
          value={value}
          swatchGuid={swatchGuid}
        />
      )}
    </>
  );
};

SuperSkuAttributeValue.displayName = 'SuperSkuAttributeValue';

SuperSkuAttributeValue.propTypes = {
  attributeType: string.isRequired,
  channel: oneOf(['desktop', 'mobile']).isRequired,
  displayInToolTip: bool,
  hoveredCombinationDetails: shape({}),
  isAvailable: bool.isRequired,
  isSelected: bool.isRequired,
  isTooltipsEnabled: bool,
  miniSwatch: bool,
  onClick: func.isRequired,
  onMouseEnter: func,
  onMouseLeave: func,
  swatchCardCombinationDetails: shape({}),
  swatchGuid: string,
  value: string.isRequired
};

SuperSkuAttributeValue.defaultProps = {
  displayInToolTip: false,
  hoveredCombinationDetails: {},
  isTooltipsEnabled: false,
  miniSwatch: false,
  onMouseEnter: () => {},
  onMouseLeave: () => {},
  swatchCardCombinationDetails: {},
  swatchGuid: ''
};
